module.exports = __webpack_public_path__ + "static/ux_2_1_eg-27ac42da3b1c3c52656ea6f5792f51af.png";